import React from "react";

const TermsArticle = ({ className = "" }) => {
  const baseClasses = "space-y-10 text-sm leading-relaxed md:text-base";
  const composedClassName = className
    ? `${baseClasses} ${className}`
    : baseClasses;

  return (
    <article className={composedClassName}>
      <section className="space-y-4">
        <h2 className="text-xl font-semibold">Introduzione</h2>
        <p>Questi Termini disciplinano</p>
        <ul className="ml-6 list-disc space-y-2">
          <li>l&apos;utilizzo di questa Applicazione e</li>
          <li>qualsiasi altro Accordo o rapporto giuridico con il Titolare</li>
        </ul>
        <p>
          in maniera vincolante. Le espressioni con l&apos;iniziale maiuscola sono
          definite nella relativa sezione di questo documento.
        </p>
        <p>L&apos;Utente è pregato di leggere attentamente questo documento.</p>
        <p>Questa Applicazione è un servizio di:</p>
        <p>Edizioni GD Via Rivoli 8 b</p>
        <p>Indirizzo email del Titolare: info@minigoal.it</p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">Da sapere a colpo d&apos;occhio</h2>
        <ul className="ml-6 list-disc space-y-2">
          <li>
            Si fa presente che determinate disposizioni di questi Termini
            potrebbero essere solo applicabili ad alcune categorie di Utenti. In
            particolare, alcune disposizioni potrebbero applicarsi solo a
            Consumatori o solo a Utenti che non agiscono come Consumatori. Tali
            limitazioni sono sempre menzionate esplicitamente in ciascuna
            clausola interessata. In caso di mancata menzione, le clausole si
            applicano a tutti gli Utenti.
          </li>
          <li>
            L&apos;accesso a questa Applicazione è consentito agli Utenti che
            soddisfano i requisiti di età specificati in questi Termini.
          </li>
        </ul>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">Condizioni d&apos;uso</h2>
        <p>
          Salvo ove diversamente specificato, le condizioni d&apos;uso di questa
          Applicazione esposte in questa sezione hanno validità generale.
          Ulteriori condizioni d&apos;uso o d&apos;accesso applicabili in particolari
          situazioni sono espressamente indicate in questo documento.
        </p>
        <p>
          Utilizzando questa Applicazione l&apos;Utente dichiara di soddisfare i
          seguenti requisiti:
        </p>
        <ul className="ml-6 list-disc space-y-2">
          <li>
            Non ci sono restrizioni riferite agli Utenti rispetto al fatto che
            essi siano Consumatori o Utenti Professionisti;
          </li>
          <li>L&apos;Utente deve avere almeno 14 anni;</li>
        </ul>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">Registrazione</h2>
        <p>
          Per usufruire del Servizio l&apos;Utente può aprire un account indicando
          tutti i dati e le informazioni richieste in maniera completa e
          veritiera. Non è possibile usufruire del Servizio senza aprire un
          account Utente.
        </p>
        <p>
          È responsabilità degli Utenti conservare le proprie credenziali
          d&apos;accesso in modo sicuro e preservarne la confidenzialità. A tal
          fine, gli Utenti devono scegliere una password che corrisponda al più
          alto livello di sicurezza disponibile su questa Applicazione.
        </p>
        <p>
          Creando un account l&apos;Utente accetta di essere pienamente
          responsabile di ogni attività posta in atto con le sue credenziali
          d&apos;accesso. Gli Utenti sono tenuti a informare il Titolare
          immediatamente e univocamente tramite i recapiti indicati in questo
          documento qualora ritengano che le proprie informazioni personali,
          quali ad esempio l&apos;account Utente, le credenziali d&apos;accesso o dati
          personali, siano state violate, illecitamente diffuse o sottratte.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">Chiusura account</h2>
        <p>
          L&apos;Utente è libero di chiudere il proprio account e cessare
          l&apos;utilizzo del Servizio in qualsiasi momento, seguendo questa
          procedura:
        </p>
        <ul className="ml-6 list-disc space-y-2">
          <li>
            Usando gli strumenti di chiusura dell&apos;account disponibili su
            questa Applicazione.
          </li>
        </ul>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">
          Sospensione e cancellazione account
        </h2>
        <p>
          Il Titolare potrà, a propria esclusiva discrezione, sospendere
          temporaneamente o procedere alla cancellazione definitiva dell&apos;account
          dell&apos;Utente qualora accerti, anche sulla base di segnalazioni o di
          elementi probatori acquisiti, una violazione espressa del presente
          regolamento ovvero la sottrazione, la copiatura, la riproduzione o la
          diffusione non autorizzata di contenuti di proprietà del Titolare o
          comunque tutelati dallo stesso, ivi compresa la realizzazione e la
          pubblicazione di screenshot, fotografie o qualsiasi altra forma di
          riproduzione e condivisione non consentita. L&apos;accertamento della
          predetta violazione potrà essere effettuato dal Titolare mediante ogni
          strumento istruttorio ritenuto necessario, fatto salvo il diritto del
          Titolare di attivare i rimedi giudiziali o extragiudiziali a tutela del
          proprio nome, della propria immagine e della propria attività
          imprenditoriale.
        </p>
        <p>
          In caso di sospensione o cancellazione dell&apos;account per le cause
          sopra indicate, tutti i crediti, i saldi, i corrispettivi o i diritti
          economici eventualmente riferibili all&apos;Utente, comunque denominati,
          non saranno restituiti né rimborsati, e resteranno acquisiti al
          patrimonio del Titolare senza che l&apos;Utente possa vantare, a qualsiasi
          titolo, alcun diritto di corresponsione, indennizzo o rimborso. Tale
          disposizione si applica in ogni ipotesi di sospensione o cancellazione
          disposta ai sensi del presente articolo, fermo restando il diritto del
          Titolare di promuovere azioni giudiziarie per la tutela dei propri
          interessi, inclusa la richiesta di risarcimento del danno subito per
          l&apos;illecita appropriazione o diffusione di contenuti.
        </p>
        <p>
          Il Titolare si riserva il diritto di sospendere o cancellare l&apos;account
          di un Utente in qualsiasi momento e senza preavviso, ove lo ritenga
          opportuno, inopportuno, offensivo o comunque contrario ai termini qui
          previsti. Tale facoltà discrezionale potrà essere esercitata previa o
          successiva notifica all&apos;Utente, secondo le modalità ritenute dal
          Titolare più idonee, senza che ciò comporti per l&apos;Utente alcuna pretesa
          risarcitoria, di rimborso o di indennizzo.
        </p>
        <p>
          La sospensione o la cancellazione dell&apos;account per fatti o omissioni
          imputabili all&apos;Utente non esonera quest&apos;ultimo dall&apos;adempimento degli
          obblighi di natura economica eventualmente maturati nei confronti del
          Titolare, ivi inclusi compensi, prezzi, penali o altri importi dovuti
          in relazione all&apos;utilizzo dei servizi. Resta salvo il diritto del
          Titolare di agire per il recupero coattivo delle somme dovute e di
          ottenere il ristoro degli eventuali danni subiti.
        </p>
        <p>
          Le misure di sospensione o cancellazione adottate ai sensi del presente
          articolo non pregiudicano l&apos;applicabilità di ulteriori rimedi civili e
          penali nei confronti dell&apos;Utente responsabile di condotte illecite, né
          incidono sui termini e sulle modalità di conservazione delle evidenze
          relative alle violazioni, che il Titolare potrà trattenere ed esibire
          in sede amministrativa o giudiziaria.
        </p>
        <p>
          La presente disciplina si applica senza pregiudizio delle eventuali
          disposizioni di legge inderogabili e dei diritti di terzi, e potrà
          essere integrata dal Titolare con procedure specifiche di gestione dei
          reclami e delle controversie, nonché con la previsione di strumenti
          idonei a garantire il contraddittorio e la verifica delle fattispecie
          contestate, nei limiti consentiti dall&apos;esercizio della facoltà
          discrezionale qui riconosciuta.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">
          Contenuti su questa Applicazione
        </h2>
        <p>
          Salvo ove diversamente specificato o chiaramente riconoscibile, tutti
          i contenuti disponibili su questa applicazione sono di proprietà di o
          forniti dal Titolare o dei/dai suoi licenzianti.
        </p>
        <p>
          Il Titolare adotta la massima cura affinché il contenuto disponibile su
          questa Applicazione non violi la normativa applicabile o diritti di
          terze parti. Tuttavia, non sempre è possibile raggiungere tale
          risultato.
        </p>
        <p>
          In tali casi, senza alcun pregiudizio ai diritti ed alle pretese
          legalmente esercitabili, gli Utenti sono pregati di indirizzare i
          relativi reclami ai recapiti specificati in questo documento.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">
          Diritti sui contenuti di questa Applicazione
        </h2>
        <p>
          Il Titolare detiene e si riserva espressamente ogni diritto di
          proprietà intellettuale sui suddetti contenuti.
        </p>
        <p>
          Gli Utenti non sono autorizzati ad usare i contenuti in alcun modo che
          non sia necessario od implicito nel corretto utilizzo del Servizio.
        </p>
        <p>
          In particolare, ma senza esclusioni, è fatto divieto agli Utenti di
          copiare, scaricare, condividere oltre i limiti sotto specificati,
          modificare, tradurre, elaborare, pubblicare, trasmettere, vendere,
          concedere sottolicenze, trasformare, trasferire/alienare a terze parti
          o creare opere derivate a partire dal contenuto disponibile su questa
          Applicazione, di permettere a terze parti di intraprendere tali
          attività tramite il proprio account Utente o dispositivo, anche a
          propria insaputa.
        </p>
        <p>
          Ove espressamente indicato su questa Applicazione, l&apos;Utente è
          autorizzato a scaricare, copiare e/o condividere determinati contenuti
          disponibili su questa Applicazione esclusivamente per scopi personali e
          non commerciali ed a condizione che sia osservata l&apos;attribuzione della
          paternità dell&apos;opera nonché l&apos;indicazione di ogni altra circostanza
          rilevante richiesta dal Titolare.
        </p>
        <p>
          Restano ferme le limitazioni ed esclusioni previste dalla normativa sul
          diritto d&apos;autore.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">Contenuti forniti dagli Utenti</h2>
        <p>
          Il Titolare consente agli Utenti di caricare, condividere o offrire i
          propri contenuti su questa Applicazione.
        </p>
        <p>
          All&apos;atto di fornire contenuti a questa Applicazione l&apos;Utente
          dichiara di essere legalmente autorizzato a farlo e conferma che detti
          contenuti non violano norme di legge e/o diritti di terzi.
        </p>
        <p>
          Gli ulteriori requisiti che i contenuti devono soddisfare per essere
          considerati “accettabili” sono specificati nella sezione relativa
          all&apos;uso ammesso.
        </p>
        <p>
          L&apos;Utente riconosce ed accetta che fornendo contenuti propri a questa
          Applicazione concede al Titolare irrevocabilmente e a titolo gratuito il
          diritto non esclusivo, valido in tutto il mondo e perpetuo (ovvero per
          la durata della protezione legale), di utilizzare, accedere,
          archiviare, riprodurre, modificare, diffondere, pubblicare, trasformare
          in opere derivate, trasmettere (incluso lo streaming) o sfruttare in
          altro modo i contenuti per fornire e promuovere il Servizio in ogni
          forma o canale mediatico. Detto diritto può essere trasferito o
          concesso in licenza a terzi.
        </p>
        <p>
          Nei limiti di legge, l&apos;Utente rinuncia all&apos;esercizio di diritti
          morali in relazione al contenuto fornito a questa Applicazione.
        </p>
        <p>
          Gli Utenti riconoscono ed accettano che i contenuti da loro offerti
          tramite questa Applicazione saranno resi disponibili alle stesse
          condizioni applicabili ai contenuti di questa Applicazione.
        </p>
        <p>
          L&apos;Utente risponde in via esclusiva dei contenuti caricati, pubblicati,
          condivisi o comunque forniti a questa Applicazione.
        </p>
        <p>
          L&apos;Utente riconosce ed accetta che il Titolare filtri o moderi tali
          contenuti dopo che sono stati resi disponibili.
        </p>
        <p>
          Pertanto, il Titolare si riserva il diritto di rifiutare, rimuovere,
          cancellare o bloccare tali contenuti a propria discrezione e di negare
          l&apos;accesso a questa Applicazione senza preavviso all&apos;Utente che li ha
          caricati se ritiene che i contenuti violino questi Termini, disposizioni
          di legge applicabili o diritti di terzi o altrimenti rappresentino un
          rischio per gli Utenti, i terzi, il Titolare stesso o la disponibilità
          del Servizio.
        </p>
        <p>
          La rimozione, cancellazione o il blocco dei contenuti non giustificano
          alcuna pretesa di risarcimento, rimborso o indennizzo in capo agli
          Utenti che hanno fornito tali contenuti.
        </p>
        <p>
          Gli Utenti accettano di mantenere indenne il Titolare da e contro ogni
          pretesa avanzata e/o danno sofferto a causa di contenuti da essi forniti
          a o offerti tramite questa Applicazione.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">
          Accessibilità dei contenuti forniti
        </h2>
        <p>
          I contenuti forniti a questa Applicazione dagli Utenti sono messi a
          disposizione alle condizioni descritte in questa sezione.
        </p>
        <h3 className="text-lg font-semibold">Contenuti pubblici</h3>
        <p>
          I contenuti destinati ad essere resi pubblici saranno automaticamente
          pubblicati su questa Applicazione dopo il caricamento o, a discrezione
          del Titolare, in un secondo tempo.
        </p>
        <p>
          Qualsiasi dato personale, identificativo o altra informazione che
          l&apos;Utente carichi unitamente al contenuto (quali, ad esempio, la
          user-ID, un avatar o nickname etc.) apparirà in collegamento con il
          contenuto pubblicato.
        </p>
        <p>
          Gli Utenti possono (e sono incoraggiati a) consultare questa
          Applicazione per scoprire chi può accedere ai contenuti da loro
          forniti.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">
          Accesso a risorse esterne
        </h2>
        <p>
          Tramite questa Applicazione gli Utenti potrebbero avere accesso a
          risorse fornite da terzi. Gli Utenti riconoscono ed accettano che il
          Titolare non ha alcun controllo su tali risorse e che pertanto non
          risponde del loro contenuto e della loro disponibilità.
        </p>
        <p>
          Le condizioni applicabili alle risorse fornite da terzi, ivi incluse
          quelle applicabili a eventuali concessioni di diritti su contenuti,
          sono determinate dagli stessi terzi e regolate nei relativi termini e
          condizioni o, in loro assenza, dalla legge.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">Uso ammesso</h2>
        <p>
          Questa Applicazione ed il Servizio possono essere utilizzati solo per
          gli scopi per i quali sono offerti, secondo questi Termini ed ai sensi
          della legge applicabile.
        </p>
        <p>
          È responsabilità esclusiva dell&apos;Utente di far sì che l&apos;uso di questa
          Applicazione e/o del Servizio non violi la legge, i regolamenti o i
          diritti di terzi.
        </p>
        <p>
          Pertanto, il Titolare si riserva il diritto di adottare ogni misura
          idonea a proteggere i propri interessi legittimi, ed in particolare di
          negare all&apos;Utente l&apos;accesso a questa Applicazione o al Servizio,
          risolvere contratti, denunciare ogni attività censurabile svolta
          tramite questa Applicazione o il Servizio alle autorità competenti – per
          esempio l&apos;autorità giudiziaria o amministrativa – ogniqualvolta
          l&apos;Utente ponga in essere o vi sia il sospetto che ponga in essere:
        </p>
        <ul className="ml-6 list-disc space-y-2">
          <li>violazioni di legge, regolamenti e/o dei Termini;</li>
          <li>lesioni di diritti di terzi;</li>
          <li>
            atti che possono pregiudicare considerevolmente i legittimi interessi
            del Titolare;
          </li>
          <li>offese al Titolare o a un terzo.</li>
        </ul>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">
          Termini e condizioni di vendita
        </h2>
        <h3 className="text-lg font-semibold">Prodotti a pagamento</h3>
        <p>
          Alcuni dei Prodotti offerti su questa Applicazione come parte del
          servizio sono a pagamento. Le tariffe, la durata e le condizioni
          applicabili alla vendita di tali Prodotti sono descritte di seguito e
          nelle rispettive sezioni di questa Applicazione.
        </p>
        <p>
          Per acquistare i Prodotti, l&apos;Utente è tenuto a registrarsi o ad
          effettuare l&apos;accesso a questa Applicazione.
        </p>
        <h3 className="text-lg font-semibold">Descrizione del prodotto</h3>
        <p>
          Prezzi, descrizioni e disponibilità dei Prodotti sono specificati nelle
          rispettive sezioni di questa Applicazione e sono soggetti a modifica
          senza preavviso.
        </p>
        <p>
          Sebbene i Prodotti su questa Applicazione siano presentati con la
          massima accuratezza tecnicamente possibile, la rappresentazione su
          questa Applicazione tramite qualsiasi mezzo (inclusi, a seconda dei
          casi, materiali grafici, immagini, colori, suoni) è da intendersi come
          mero riferimento e non implica alcuna garanzia in merito alle
          caratteristiche del Prodotto acquistato.
        </p>
        <p>
          Le caratteristiche del Prodotto selezionato saranno specificate durante
          la procedura d&apos;acquisto.
        </p>
        <h3 className="text-lg font-semibold">Procedura d&apos;acquisto</h3>
        <p>
          Ogni fase, dalla scelta del prodotto fino all&apos;inoltro dell&apos;ordine, fa
          parte della procedura d&apos;acquisto.
        </p>
        <p>La procedura d&apos;acquisto comprende i seguenti passaggi:</p>
        <ul className="ml-6 list-disc space-y-2">
          <li>
            Gli Utenti sono pregati di scegliere il Prodotto desiderato e di
            verificare la loro scelta d&apos;acquisto.
          </li>
          <li>
            Dopo aver controllato le informazioni visibili nella scelta
            d&apos;acquisto, gli Utenti possono effettuare l&apos;ordine inoltrandolo.
          </li>
        </ul>
        <h3 className="text-lg font-semibold">Invio dell&apos;ordine</h3>
        <p>L&apos;invio dell&apos;ordine comporta quanto segue:</p>
        <ul className="ml-6 list-disc space-y-2">
          <li>
            L&apos;invio dell&apos;ordine da parte dell&apos;Utente determina la conclusione
            del contratto e fa sorgere in capo all&apos;Utente l&apos;obbligo di pagare
            prezzo, tasse ed eventuali ulteriori oneri e spese, così come
            specificato nella pagina dell&apos;ordine.
          </li>
          <li>
            Nel caso in cui il Prodotto acquistato richieda un&apos;azione da parte
            dell&apos;Utente, come la fornitura di informazioni o dati personali,
            specificazioni o richieste particolari, l&apos;inoltro dell&apos;ordine
            costituisce in capo all&apos;Utente anche l&apos;obbligo di collaborare di
            conseguenza.
          </li>
          <li>
            Una volta inoltrato l&apos;ordine, agli Utenti sarà inviata una conferma
            di ricezione dell&apos;ordine.
          </li>
        </ul>
        <p>
          Tutte le notifiche relative alla procedura d&apos;acquisto sopra descritta
          saranno inviate all&apos;indirizzo di posta elettronica fornito
          dall&apos;Utente a tal fine.
        </p>
        <h3 className="text-lg font-semibold">Prezzi</h3>
        <p>
          Durante la procedura d&apos;acquisto e prima dell&apos;inoltro dell&apos;ordine,
          gli Utenti vengono debitamente informati di tutte le commissioni, tasse
          e costi (comprese eventuali spese di spedizione) che saranno loro
          addebitati.
        </p>
        <p>I prezzi su questa Applicazione:</p>
        <ul className="ml-6 list-disc space-y-2">
          <li>includono tutte le commissioni, tasse e costi applicabili.</li>
        </ul>
        <h3 className="text-lg font-semibold">Mezzi di pagamento</h3>
        <p>
          I dettagli relativi ai mezzi di pagamento accettati sono evidenziati
          durante la procedura d&apos;acquisto.
        </p>
        <p>
          Alcuni mezzi di pagamento sono legati ad ulteriori condizioni o
          comportano costi aggiuntivi. Le informazioni dettagliate sono riportate
          nella relativa sezione di questa Applicazione.
        </p>
        <p>
          Tutti i pagamenti vengono gestiti autonomamente da servizi terzi.
          Pertanto, questa Applicazione non raccoglie dati relativi al pagamento
          – quali numeri di carta di credito – ma riceve una notifica una volta
          che il pagamento è andato a buon fine. Per ricevere ulteriori
          informazioni sul trattamento dei dati personali e sui relativi diritti,
          l&apos;Utente può fare riferimento alla privacy policy di questa
          Applicazione.
        </p>
        <p>
          Nel caso in cui il pagamento effettuato con uno dei mezzi disponibili
          fallisca o venga rifiutato dal fornitore di servizi di pagamento, il
          Titolare non è obbligato a eseguire l&apos;ordine. Nel caso in cui il
          pagamento non vada a buon fine, il Titolare si riserva il diritto di
          richiedere all&apos;Utente il rimborso di qualsiasi spesa o danno correlato.
        </p>
        <h3 className="text-lg font-semibold">
          Autorizzazione per pagamenti futuri via PayPal
        </h3>
        <p>
          Nel caso in cui l&apos;Utente autorizzi la funzione PayPal che consente
          acquisti futuri, questa Applicazione memorizzerà un codice
          identificativo collegato all&apos;account PayPal dell&apos;Utente. In tal modo
          questa Applicazione potrà elaborare automaticamente i pagamenti per
          acquisti futuri o per il pagamento di rate periodiche di un acquisto
          pregresso.
        </p>
        <p>
          L&apos;autorizzazione può essere revocata in ogni momento contattando il
          Titolare o modificando le impostazioni personali di PayPal.
        </p>
        <h3 className="text-lg font-semibold">Riserva di proprietà</h3>
        <p>
          Fino alla ricezione del pagamento del prezzo integrale di acquisto da
          parte del Titolare, l&apos;Utente non acquista la proprietà dei Prodotti
          ordinati.
        </p>
        <h3 className="text-lg font-semibold">Riserva dei diritti d&apos;uso</h3>
        <p>
          Fino alla ricezione del pagamento del prezzo integrale di acquisto da
          parte del Titolare, l&apos;Utente non acquista i diritti d&apos;uso dei
          Prodotti ordinati.
        </p>
        <h3 className="text-lg font-semibold">Consegna</h3>
        <h4 className="text-base font-semibold">
          Consegna di contenuti digitali
        </h4>
        <p>
          Salvo ove diversamente specificato, il contenuto digitale acquistato su
          questa Applicazione viene consegnato tramite download sul dispositivo o
          sui dispositivi scelti dall&apos;Utente.
        </p>
        <p>
          Gli Utenti riconoscono ed accettano che, per scaricare e/o utilizzare il
          Prodotto, il dispositivo o i dispositivi prescelti ed il rispettivo
          software (compresi i sistemi operativi) debbano essere legali, d&apos;uso
          comune, aggiornati e in linea con gli attuali standard di mercato.
        </p>
        <p>
          Gli Utenti riconoscono ed accettano che la possibilità di scaricare il
          Prodotto acquistato potrebbe essere limitata nel tempo e nello spazio.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">
          Limitazione di responsabilità e manleva
        </h2>
        <p>
          Salvo ove diversamente specificato o concordato con gli Utenti, la
          responsabilità del Titolare per danni connessi all&apos;esecuzione
          dell&apos;Accordo sarà esclusa, limitata e/o ridotta nei limiti massimi
          consentiti dalla legge applicabile.
        </p>
        <h3 className="text-lg font-semibold">Manleva</h3>
        <p>
          L&apos;Utente si impegna a manlevare e tenere indenne il Titolare e i suoi
          sottoposti, affiliati, funzionari, agenti, contitolari del marchio,
          partner e dipendenti nella misura di legge da qualsivoglia rivendicazione
          o pretesa – compresi, senza alcuna limitazione, oneri e spese legali –
          avanzata da terzi a causa di o in collegamento con comportamenti in
          violazione dei presenti Termini, di diritti di terzi o di legge, posti
          in essere in collegamento con l&apos;utilizzo del Servizio e addebitabili
          all&apos;Utente, ai suoi affiliati, funzionari, agenti, contitolari del
          marchio, partner e dipendenti, a titolo di colpa.
        </p>
        <h3 className="text-lg font-semibold">
          Limitazione della responsabilità per le attività dell&apos;Utente su questa
          Applicazione
        </h3>
        <p>
          Salvo ove diversamente specificato e fatte salve le disposizioni di
          legge applicabili, è esclusa ogni pretesa risarcitoria nei confronti del
          Titolare (o di qualsiasi persona fisica o giuridica che agisca per suo
          conto).
        </p>
        <p>
          Quanto precede non limita la responsabilità del Titolare per morte,
          danno alla persona o all&apos;integrità fisica o mentale, danni derivanti
          dalla violazione di obblighi contrattuali essenziali, quali gli obblighi
          strettamente necessari al raggiungimento della causa del contratto, e/o
          ai danni provocati con dolo o colpa grave, a condizione che l&apos;utilizzo
          di questa Applicazione da parte dell&apos;Utente sia stato idoneo e corretto.
        </p>
        <p>
          Salvo che i danni siano stati causati con dolo o colpa grave o incidano
          sulla vita e/o l&apos;integrità personale, fisica o mentale, il Titolare
          risponde solo nella misura del danno tipico per il tipo di contratto e
          prevedibile al momento della conclusione.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">Disposizioni comuni</h2>
        <h3 className="text-lg font-semibold">Nessuna rinuncia implicita</h3>
        <p>
          Il mancato esercizio di diritti di legge o pretese derivanti da questi
          Termini da parte del Titolare non costituisce rinuncia agli stessi.
          Nessuna rinuncia può essere considerata definitiva in relazione ad uno
          specifico diritto o a qualsiasi altro diritto.
        </p>
        <h3 className="text-lg font-semibold">Interruzione del Servizio</h3>
        <p>
          Per garantire il miglior livello di servizio possibile, il Titolare si
          riserva di interrompere il Servizio per finalità di manutenzione,
          aggiornamenti di sistema o per qualsiasi altra modifica, dandone idonea
          notizia agli Utenti.
        </p>
        <p>
          Nei limiti di legge, il Titolare si riserva di sospendere o cessare
          completamente l&apos;attività del Servizio. In caso di cessazione
          dell&apos;attività del Servizio, il Titolare si adopererà affinché gli
          Utenti possano estrarre i propri dati personali e le informazioni e
          rispetterà i diritti degli Utenti relativi all&apos;utilizzo continuato del
          prodotto e/o al risarcimento, secondo le disposizioni di legge.
        </p>
        <p>
          Inoltre, il Servizio potrebbe non essere disponibile per cause che si
          sottraggono al ragionevole controllo del Titolare, quali cause di forza
          maggiore (per esempio malfunzionamenti infrastrutturali, blackout etc.).
        </p>
        <h3 className="text-lg font-semibold">
          Misure sanzionatorie e penalità in caso di utilizzo improprio del
          servizio e blocco dell&apos;account
        </h3>
        <h4 className="text-base font-semibold">Ambito e principio generale</h4>
        <p>
          Il presente articolo disciplina le modalità operative di intervento del
          Titolare in caso di utilizzo improprio del servizio, con particolare
          riguardo alla rilevazione, anche automatizzata, di comportamenti
          consistenti nella riproduzione, acquisizione o diffusione non
          autorizzata di materiali protetti (a titolo esemplificativo,
          screenshot, fotografie o altre forme di copia non consentita). Le
          previsioni che seguono integrano le disposizioni contrattuali e
          regolamentari vigenti e si applicano a tutti gli Utenti senza
          esclusione.
        </p>
        <h4 className="text-base font-semibold">
          Rilevazione automatizzata e blocco dell&apos;account
        </h4>
        <p>
          Il sistema informatico, comprensivo dell&apos;applicazione e del sito
          internet gestiti dal Titolare, è dotato di strumenti di controllo e
          monitoraggio atti a identificare pattern di utilizzo incompatibili con
          le condizioni contrattuali e regolamentari. Qualora il sistema rilevi,
          in base a criteri di profilazione tecnica e logica, un tentativo di
          acquisizione o diffusione non autorizzata di contenuti (tra cui, a
          titolo esemplificativo, screenshot, fotografie, screen recording o
          azioni similari su materiale non liberato all&apos;uso), il sistema potrà
          porre in essere l&apos;immediato blocco dell&apos;account dell&apos;Utente
          responsabile del tentativo.
        </p>
        <p>
          Ad ogni singolo tentativo rilevato e classificato secondo le predette
          modalità, il sistema provvederà ad effettuare il blocco dell&apos;account.
          Tale blocco potrà essere revocato esclusivamente dal Titolare, a seguito
          di verifica istruttoria svolta dal medesimo, e non potrà essere superato
          dall&apos;Utente mediante alcuna autonoma azione tecnica.
        </p>
        <h4 className="text-base font-semibold">Ripristino e recidiva</h4>
        <p>
          Il primo blocco dell&apos;account potrà, a discrezione del Titolare,
          essere seguito da un&apos;istruttoria volta ad accertare le circostanze e
          l&apos;entità della violazione; al termine di detta istruttoria il Titolare
          potrà disporre il ripristino dell&apos;account oppure mantenerne la
          sospensione.
        </p>
        <p>
          In caso di un secondo blocco, derivante da un&apos;ulteriore rilevazione di
          utilizzo improprio come sopra definito, l&apos;account sarà soggetto a
          cancellazione definitiva, conformemente a quanto previsto dall&apos;apposito
          articolo del presente regolamento che disciplina la cancellazione
          dell&apos;account per violazioni ripetute e gravi.
        </p>
        <h4 className="text-base font-semibold">
          Determinazione della somma a titolo di risarcimento bonario e obbligo di
          pagamento
       </h4>
        <p>
          Ferma restando la possibilità per il Titolare di agire per la più ampia
          tutela dei propri diritti, il verificarsi di un comportamento
          fraudolento consistente nella acquisizione o diffusione non autorizzata
          di contenuti, accertato anche extragiudizialmente mediante documento
          scritto rilasciato dal responsabile del sistema informatico (app e sito
          internet) ovvero dal Titolare, costituisce titolo per la richiesta, da
          parte del Titolare medesimo, di un importo forfait pari a Euro 1.000,00
          (mille/00) a titolo di risarcimento bonario.
        </p>
        <p>
          L&apos;Utente si riconosce sin d&apos;ora debitore di tale somma e si obbliga a
          corrispondere l&apos;importo al Titolare entro il termine di 30 (trenta)
          giorni decorrenti dalla data di ricezione della comunicazione scritta di
          accertamento. Il mancato pagamento entro il predetto termine costituisce
          inadempimento e legittima il Titolare a promuovere le azioni legali e i
          provvedimenti conservativi ritenuti opportuni per il recupero delle
          somme e per il ristoro del danno, nonché ad applicare ulteriori aggravi
          contrattuali previsti dal presente regolamento.
        </p>
        <h4 className="text-base font-semibold">
          Facoltà di agire per via giudiziale e riserva di ulteriori rimedi
        </h4>
        <p>
          Il pagamento della somma di cui sopra non preclude né esclude la
          possibilità per il Titolare di adire le vie legali qualora, a suo
          giudizio, la condotta posta in essere dall&apos;Utente abbia arrecato una
          lesione di particolare gravità all&apos;immagine, al nome, ai diritti di
          proprietà intellettuale o all&apos;attività imprenditoriale del Titolare.
        </p>
        <p>
          Le misure di cui al presente articolo si aggiungono ai rimedi civili e
          penali riconosciuti dalla legge. Si richiama, tra gli altri, il disposto
          dell&apos;art. 614-bis c.p. (accesso abusivo ad un sistema informatico o
          telematico) e, per la tutela del diritto d&apos;autore e dei diritti
          connessi, le norme della legge sul diritto d&apos;autore (l. 22 aprile 1941,
          n. 633), nonché i principi civilistici in tema di responsabilità
          extracontrattuale (art. 2043 c.c.) e di risarcimento del danno. In via
          interpretativa, la quantificazione del risarcimento bonario non esclude
          la valutazione giudiziale del maggior danno effettivamente subito, ai
          sensi della giurisprudenza che ammette la liquidazione equitativa o
          parametrica nei casi di difficile quantificazione (si vedano, tra le
          altre, orientamenti consolidati relativi alla quantificazione del danno
          da violazione del diritto d&apos;autore e da concorrenza sleale).
        </p>
        <h4 className="text-base font-semibold">
          Garanzie procedurali e conservazione delle evidenze
        </h4>
        <p>
          Il Titolare si riserva di notificare all&apos;Utente il provvedimento di
          blocco e di fornire, ove possibile, le ragioni generali del provvedimento
          e le indicazioni per il contraddittorio. Tuttavia, in presenza di fatti
          che possano configurare un pregiudizio irreparabile o l&apos;alterazione
          delle prove, il Titolare potrà procedere senza preventiva comunicazione,
          riservandosi di darne tempestiva informativa all&apos;Utente.
        </p>
        <p>
          Tutte le evidenze tecniche, log file, comunicazioni e documenti acquisiti
          nel corso delle verifiche saranno conservati dal Titolare e potranno
          essere esibiti in sede giudiziale o extragiudiziale a supporto
          dell&apos;accertamento della responsabilità dell&apos;Utente.
        </p>
        <h4 className="text-base font-semibold">Disposizioni finali</h4>
        <p>
          Le presenti misure non escludono né limitano eventuali obblighi di legge
          inderogabili né diritti di terzi. L&apos;applicazione delle penalità e delle
          misure di blocco si intende senza pregiudizio per eventuali
          responsabilità penali e civili, nonché per il diritto del Titolare di
          richiedere il ristoro integrale del danno qualora il pregiudizio subito
          superi la somma forfettaria qui prevista.
        </p>
        <p>
          Per l&apos;interpretazione e l&apos;integrazione delle clausole che precedono
          si rinvia, in via generale, ai principi del codice civile in materia
          contrattuale e precontrattuale e al principio di buona fede (art. 1175 e
          art. 1375 c.c.).
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">Rivendita del Servizio</h2>
        <p>
          Gli Utenti non sono autorizzati a riprodurre, duplicare, copiare,
          vendere, rivendere o sfruttare questa Applicazione o il Servizio in toto
          o in parte senza previo consenso scritto del Titolare, espresso
          direttamente o attraverso un legittimo programma di rivendite.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">Privacy policy</h2>
        <p>
          Le informazioni sul trattamento dei dati personali sono contenute nella
          privacy policy di questa Applicazione, la quale forma parte integrante e
          vincolante dei Termini.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">Proprietà intellettuale</h2>
        <p>
          Senza pregiudizio ad alcuna previsione più specifica contenuta nei
          Termini, i diritti di proprietà intellettuale ed industriale, quali ad
          esempio diritti d&apos;autore, marchi, brevetti e modelli relativi a questa
          Applicazione sono detenuti in via esclusiva dal Titolare o dai suoi
          licenzianti e sono tutelati ai sensi della normativa e dei trattati
          internazionali applicabili alla proprietà intellettuale.
        </p>
        <p>
          Tutti i marchi – denominativi o figurativi – ed ogni altro segno
          distintivo, ditta, marchio di servizio, illustrazione, immagine o logo
          che appaiono in collegamento con questa Applicazione sono e restano di
          esclusiva proprietà del Titolare o dei suoi licenzianti e sono tutelati
          ai sensi della normativa e dei trattati internazionali applicabili alla
          proprietà intellettuale.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">Modifiche dei Termini</h2>
        <p>
          Il Titolare si riserva il diritto di modificare i Termini in ogni
          momento. In tal caso, il Titolare darà opportuna notizia delle modifiche
          agli Utenti.
        </p>
        <p>
          Le modifiche avranno effetto nel rapporto con l&apos;Utente solo a partire
          dal momento comunicato all&apos;Utente.
        </p>
        <p>
          L&apos;utilizzo continuato del Servizio implica l&apos;accettazione
          dell&apos;Utente dei Termini aggiornati. Se l&apos;Utente non desidera accettare
          le modifiche, deve cessare l&apos;utilizzo del Servizio e può recedere
          dall&apos;Accordo.
        </p>
        <p>
          La versione precedente continua a disciplinare il rapporto fino
          all&apos;accettazione delle modifiche da parte dell&apos;Utente. Tale versione
          può essere richiesta al Titolare.
        </p>
        <p>
          Se richiesto dalla legge, il Titolare comunicherà in anticipo agli
          Utenti la data di entrata in vigore dei Termini modificati.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">Cessione del contratto</h2>
        <p>
          Il Titolare si riserva il diritto di trasferire, cedere, disporre di,
          novare o appaltare singoli o tutti i diritti e le obbligazioni secondo
          questi Termini, avendo riguardo per gli interessi legittimi degli
          Utenti.
        </p>
        <p>
          Si applicano le disposizioni relative alla modifica di questi Termini.
        </p>
        <p>
          L&apos;Utente non è autorizzato a cedere o trasferire i propri diritti e le
          proprie obbligazioni secondo i Termini senza il consenso scritto del
          Titolare.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">Contatti</h2>
        <p>
          Tutte le comunicazioni inerenti all&apos;uso di questa Applicazione devono
          essere inviate ai recapiti indicati in questo documento.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">Clausola di salvaguardia</h2>
        <p>
          Qualora alcuna delle disposizioni di questi Termini dovesse essere o
          divenire nulla o inefficace ai sensi della legge applicabile, la nullità
          o inefficacia di tale disposizione non provoca inefficacia delle
          restanti previsioni, che permangono pertanto valide ed efficaci.
        </p>
        <h3 className="text-lg font-semibold">Utenti USA</h3>
        <p>
          Qualsiasi disposizione invalida o inefficace sarà interpretata ed
          adattata nei limiti necessari per renderla valida, efficace e conforme
          alla finalità originaria.
        </p>
        <p>
          Questi Termini costituiscono l&apos;intero accordo tra Utente e Titolare
          con riferimento all&apos;oggetto regolato e prevalgono su ogni altra
          comunicazione, compresi eventuali accordi precedenti, tra le parti in
          merito all&apos;oggetto regolato.
        </p>
        <p>Questi Termini saranno attuati nella più ampia misura consentita dalla legge.</p>
        <h3 className="text-lg font-semibold">Utenti europei</h3>
        <p>
          Qualora una disposizione di questi Termini dovesse essere o divenire
          nulla, invalida o inefficace, le parti si adopereranno per individuare
          in via amichevole una disposizione valida ed efficace sostitutiva di
          quella nulla, invalida o inefficace.
        </p>
        <p>
          In caso di mancato accordo nei termini predetti, se permesso o previsto
          dalla legge applicabile, la disposizione nulla, invalida o inefficace
          sarà sostituita dalla disciplina legale applicabile.
        </p>
        <p>
          Fermo restando quanto sopra, la nullità, invalidità o inefficacia di una
          specifica disposizione di questi Termini non comporta nullità dell&apos;intero
          Accordo, a meno che le disposizioni nulle, invalide o inefficaci nel quadro
          dell&apos;Accordo siano essenziali o di tale importanza, che le parti non
          avrebbero concluso il contratto se avessero saputo che la disposizione
          sarebbe stata invalida, ovvero in casi in cui le disposizioni residue
          comporterebbero un onere eccessivo ed inaccettabile per una delle parti.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">Legge applicabile</h2>
        <p>
          I Termini sono disciplinati dalla legge del luogo in cui è stabilito il
          Titolare, così come indicato nella relativa sezione di questo documento
          a prescindere dalle norme di conflitto.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">Foro competente</h2>
        <p>
          La competenza esclusiva a conoscere qualsiasi controversia derivante da
          o in collegamento con i Termini spetta al giudice del luogo in cui il
          Titolare è stabilito, così come indicato nella relativa sezione di
          questo documento.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold">
          Risoluzione delle controversie
        </h2>
        <h3 className="text-lg font-semibold">
          Composizione amichevole delle controversie
        </h3>
        <p>
          Gli Utenti possono segnalare eventuali controversie al Titolare, che
          cercherà di risolvere in via amichevole.
        </p>
        <p>
          Per quanto resti impregiudicato il diritto degli Utenti di promuovere
          un&apos;azione in giudizio, in caso di controversie inerenti all&apos;uso di
          questa Applicazione o al Servizio, gli Utenti sono pregati di contattare
          il Titolare ai recapiti indicati in questo documento.
        </p>
        <p>
          L&apos;Utente può indirizzare un reclamo all&apos;indirizzo e-mail del Titolare
          indicato in questo documento, includendo una breve descrizione e, se del
          caso, i dettagli dell&apos;ordine, acquisto o account interessato.
        </p>
        <p>
          Il Titolare provvederà ad evadere la richiesta senza indebito ritardo ed
          entro 3 giorni dalla sua ricezione.
        </p>
      </section>
    </article>
  );
};

export default TermsArticle;
